import React from 'react'
import { connect } from 'react-redux'
import Icon from 'components/icon/icon'
import moment from 'moment'

import { getVersionById } from 'state/selectors'

import { 
    formatFileDate,
    formatByTimeZone
} from 'utils'

const FileFileVersion = ({ version, deleteVersion }) => (
    <li>
        <span>
            { formatByTimeZone(moment(),'',true).diff(moment(version.created_at), 'days') == 0 ?
                formatFileDate(version.created_at)+' today'
                :
                formatByTimeZone(version.created_at,'h:mma Do MMMM')
            }
        </span>
        <div className="file-controls">
            <a href={version.url} download>
                <Icon name="fe-download" />
            </a>
            <button onClick={_ => deleteVersion(version)}>
                <Icon name="fe-trash-2" />
            </button>
        </div>
    </li>
)

const mapStateToProps = (state, props) => ({
    version: getVersionById(state, props.id)
})

export default connect(mapStateToProps)(FileFileVersion)


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-files/tabs/file-versions-file.jsx